import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "calendar-settings flex-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "calendar-settings__header header-4 flex-center" }, "Manage Calendars", -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "calendar-settings__google btn-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Google Calendar", -1 /* HOISTED */)
const _hoisted_5 = {
  key: 1,
  class: "calendar-settings__microsoft btn-container"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Microsoft Calendar", -1 /* HOISTED */)
const _hoisted_7 = {
  key: 2,
  class: "calendar-settings__spacer"
}
const _hoisted_8 = { class: "calendar-settings__exit btn-container" }
const _hoisted_9 = {
  key: 3,
  class: "loader-container flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!$setup.microsoftActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(_toDisplayString($setup.googleMessage), 1 /* TEXT */),
          (!$setup.googleActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary link-button",
                onClick: $setup.doLinkGoogle
              }, "Link"))
            : _createCommentVNode("v-if", true),
          ($setup.googleActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "outline unlink-button",
                onClick: $setup.doUnlinkGoogle
              }, "Unlink"))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.googleActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString($setup.microsoftMessage), 1 /* TEXT */),
          _createElementVNode("span", null, _toDisplayString($setup.microsoftEmail), 1 /* TEXT */),
          (!$setup.microsoftActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "primary link-button",
                onClick: $setup.doLinkMicrosoft
              }, "Link"))
            : _createCommentVNode("v-if", true),
          ($setup.microsoftActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "outline unlink-button",
                onClick: $setup.doUnlinkMicrosoft
              }, "Unlink"))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.googleActive || $setup.microsoftActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "borderless",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('close')))
      }, "Back")
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode($setup["VLoader"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}